import { z } from "zod";

export const CreateExpenseCategorySchema = z.object({
  code: z.string().min(1),
  name: z.string().min(1),
  parentId: z.string().optional(),
  sortOrder: z.coerce.number().int().optional(),
  isActive: z.boolean().optional(),
});

export type CreateExpenseCategoryDTO = z.infer<
  typeof CreateExpenseCategorySchema
>;

export const UpdateExpenseCategorySchema = z.object({
  code: z.string().min(1).optional(),
  name: z.string().min(1).optional(),
  parentId: z.string().nullable().optional(),
  sortOrder: z.coerce.number().int().optional(),
  isActive: z.boolean().optional(),
});

export type UpdateExpenseCategoryDTO = z.infer<
  typeof UpdateExpenseCategorySchema
>;
